import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { Holiday } from "@/models/holiday.model"

export const useHolidayStore = defineStore("holidayStore", () => {
  const holidays: Ref<Holiday[]> = ref([])

  return { holidays }
})
